<script>
    import CustomTooltip from "./CustomTooltip.svelte";

    export let info;
    export let position = "";
    export let zIndex = 9;
    export let tooltipClass = "";

</script>

<CustomTooltip 
    zIndex={zIndex}
    contentClass="max-h-60 overflow-y-auto overflow-x-hidden min-w-0"
    tooltipPosition={position}>
    <div class="cursor-pointer" slot="tooltipTrigger">
        <i
            class="fa-solid fa-circle-info"
        >
        </i>
    </div>

    <p class={`m-0 break-words [overflow-wrap:anywhere] z-[99999] hyphens-auto ${tooltipClass}`}>
        {info}
    </p>
</CustomTooltip>